var React = require('react');

function Hamburger (props) {
    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"hamburger meny"),React.createElement("path",{"d":"M1 8a1 1 0 1 1 0-2h18a1 1 0 0 1 0 2H1zm0 6a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2H1zM1 2a1 1 0 1 1 0-2h18a1 1 0 0 1 0 2H1z","fillRule":"nonzero","key":1})]);
}

Hamburger.displayName = "Hamburger";

Hamburger.defaultProps = {"viewBox":"0 0 20 14"};

module.exports = Hamburger;

Hamburger.default = Hamburger;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/hamburger.svg
// module id = 1270
// module chunks = 0